
import React from "react";
import { PostSection } from "@/components/blog/PostSection";

export function HerramientasSection() {
  return (
    <PostSection id="herramientas" title="Las herramientas que lideran el movimiento">
      <h3 id="lovable" className="text-xl font-semibold text-white mt-4 mb-4">
        Lovable
      </h3>
      <p className="text-gray-300 mb-6">
        <strong className="text-white">Lovable</strong> es en este momento la herramienta más completa para construir aplicaciones web completas sin código. Genera React, se conecta nativamente con Supabase como backend, gestiona autenticación, base de datos y lógica de negocio. Ideal para SaaS, herramientas internas y MVPs con lógica compleja.
      </p>

      <h3 id="bolt-cursor-v0" className="text-xl font-semibold text-white mt-8 mb-4">
        Bolt, Cursor y v0
      </h3>
      <p className="text-gray-300 mb-4">
        <strong className="text-white">Bolt</strong> de StackBlitz tiene un enfoque más técnico, orientado a desarrolladores que quieren acelerar su flujo de trabajo. Genera código full-stack y permite editarlo directamente en el navegador.
      </p>
      <p className="text-gray-300 mb-4">
        <strong className="text-white">v0 de Vercel</strong> está especializado en componentes de interfaz de usuario. Si necesitas construir la parte visual de una aplicación rápidamente, con componentes React limpios y bien estructurados, v0 es una referencia.
      </p>
      <p className="text-gray-300 mb-6">
        <strong className="text-white">Cursor</strong> es el editor de código que más ha crecido este año entre desarrolladores que quieren mantener control total sobre el código pero con IA integrada en cada paso del proceso.
      </p>

      <div className="bg-seo-dark/60 border border-seo-blue/20 rounded-lg p-5 mb-6">
        <p className="text-gray-300 text-sm">
          <strong className="text-white">¿Cuál elegir?</strong> Si no tienes perfil técnico y quieres lanzar un producto completo, Lovable es la opción más directa. Si tienes conocimientos básicos de desarrollo y quieres multiplicar tu velocidad, Cursor cambia completamente lo que es posible.
        </p>
      </div>
    </PostSection>
  );
}
